/**
 * MOSA-908. How the user entered the Sheets wizard.
 *
 * `choice` is the first screen when there is no link. A landing-page link
 * skips it. Drive browse and paste keep the same probe and review steps.
 */

export type SheetsEntryMode = "choice" | "paste" | "browse";

/**
 * Pick the first mode from the URL and any restored session facts.
 * A pasted or restored link never shows the choice screen.
 */
export function initialSheetsEntryMode(args: {
  hasLink: boolean;
  hasPickedFile: boolean;
}): SheetsEntryMode {
  if (args.hasLink || args.hasPickedFile) {
    return "paste";
  }
  return "choice";
}

/** True when the Picker must list every sheet the user can open. */
export function isBrowsePickerMode(mode: SheetsEntryMode): boolean {
  return mode === "browse";
}
